import React from 'react';

export default function WheelPage() {
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <iframe
        src="/wheel/index.html"
        title="幸運大轉盤"
        style={{ width: '100%', height: '100vh', border: 'none' }}
      />
    </div>
  );
}
